module.exports = __webpack_public_path__ + "img/meta-knight-min.48eddc02.png";